import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import {CssBaseline, Typography, Stack, Card as MuiCard, styled, Divider } from '@mui/material';
import TextAreaWithButton from '../components/common/TextAreaWithButton';
import TextField from '@mui/material/TextField';
import Snackbar from '@mui/material/Snackbar';
import ContactUs from '../components/feature-specific/ContactUs';
import Aadhar from './Aadhar';
import PopUpAlert from '../components/common/PopUpAlert';

import { useLocation } from 'react-router-dom';
import CustomizedSnackbars from '../components/common/CustomizedSnackbars';
import Banner from '../components/feature-specific/Banner';
import { useSnackbar } from '../SnackbarProvider';


interface ValidateOtpResponse {
  status: string;
  success: boolean;
  data:string;
}

const Card = styled(MuiCard)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    width: '100%',
    padding: theme.spacing(4),
    gap: theme.spacing(2),
    margin: 'auto',
    marginTop:"0px",
    [theme.breakpoints.up('sm')]: {
      maxWidth: '450px',
    },
    boxShadow:
      'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
}));

const SignInContainer = styled(Stack)(({ theme }) => ({
    padding: 20,
    marginTop: '0',
    '&::before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      zIndex: -1,
      inset: 0,
      backgroundImage:
        'radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))',
      backgroundRepeat: 'no-repeat',
      ...theme.applyStyles('dark', {
        backgroundImage:
          'radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))',
      }),
    },
}));

const Demo: React.FC = () => {
  const [otp, setOtp] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [timer, setTimer] = useState<number>(0);
  const [mobileNumber,setMobileNumber] = useState('9876543210');
  const [otpSent, setOtpSent] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const [phoneVerified, setPhoneVerified] = useState<boolean>(false);
  const location = useLocation();
  const {phone,id,name} = location.state ||{};
  const [user,setUser] = useState<{phone:any,id:any,name:any}>({phone:"",id:"",name:""});
  const {showSnackbar} = useSnackbar();

  interface UserDataResponse {
    name: string;
    ID: string;
  }

  interface SendOtpResponse{
    phoneNumber:string;
    smsFlowType:string;
  }

  useEffect(()=>{
    const prevphone = location.state?.phone;
    const previd = location.state?.id;
    const prevname = location.state?.name;
    if(prevphone && previd && prevname){
      setUser({phone:prevphone,id:previd,name:prevname})
    }
    else{
      const newPhone = localStorage.getItem('mobile'); 
      const newId = localStorage.getItem('name'); 
      const newName = localStorage.getItem('id');
      setUser({phone:newPhone,id:newId,name:newName})
    }
  },[])

  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (timer > 0 && !isLoading) {
      interval = setInterval(() => {
        setTimer(prev => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [timer, isLoading]);

  const validatePhoneNumber = (number: string): boolean => {
    const isValidLength = number.length === 10;
    const isAllDigits = /^\d+$/.test(number);
    return isValidLength && isAllDigits;
  };

  const onSend = async (): Promise<void> => {
    console.log(user);
    setErrorMessage('');
    if (!validatePhoneNumber(mobileNumber)) {
      setErrorMessage('Please enter a valid 10-digit phone number.');
    } else {
      setErrorMessage('');
      
      setIsLoading(true);
      try {
        const response = await axios.post<SendOtpResponse>(
          'https://promoter-api.benow.in/api/kyc/v1/auth/send-sms',
          { mobileNumber:user.phone, smsFlowType:'OTP'  }
          
        );         
        if(response.status===200){
          setOtpSent(true);
          showSnackbar("OTP sent successfully",'success');
          setOtpSent(true);
          setTimer(30);
          setIsLoading(false);
        }
      } 
      catch (error:any) {
          switch (error.status) {
            case 404:
              setErrorMessage('Promoter (user) not found.');
              break;
            case 403:
              setErrorMessage('You are not authorized to send the OTP. Please check your API credentials.');
              break;
            case 500:
              setErrorMessage('Internal server error. Please try again later.');
              break;
            default:
              setErrorMessage('An unexpected error occurred.');
          }
        setIsLoading(false);
        setErrorMessage('Failed to send OTP. Please try again.');
        
      } finally {
        setIsLoading(false);
      }
    }
  };

  function validateOtp(otp: string): boolean {
    // Define criteria: OTP should be 6 digits and numeric
    const otpRegex = /^\d{6}$/;
  
    // Test the OTP against the regex
    return otpRegex.test(otp);
  }
  const onVerify = async (): Promise<void> => {
    if (!validateOtp(otp)) {
      setErrorMessage("Please enter valid 6-digit OTP");
    } else {
      try {
        console.log(phone);
        console.log(otp);
        const response = await axios.post<ValidateOtpResponse>(
          'https://promoter-api.benow.in/api/kyc/v1/auth/validate-otp',
          { mobileNumber:user.phone, otpNumber:otp }
        );
        switch (response.status) {
          case 200:
            if (response.status === 200) {
              if (response.data.status === 'SUCCESS') {
                setPhoneVerified(true);
                showSnackbar('OTP verified successfully', 'success');
                
                // Store JWT in localStorage
                const token = response.data.data;
                localStorage.setItem('authToken', token);
                console.log(id);
                
                navigate('/kyc-verify', { state: { id, phone } });
              } else {
                setErrorMessage('Invalid OTP. Please try again.');
                setOtp('');
                showSnackbar('Invalid OTP. Please try again.', 'error');
              }
            }
        }
        setTimer(0);
      } catch (error:any) {
        if (error.response) {
          const { status } = error.response;
      
          switch (status) {
            case 401:
              setErrorMessage('Invalid OTP. Please try again.');
              showSnackbar('Invalid OTP. Please try again.', 'error');
              break;
            case 410:
              setErrorMessage('OTP has expired. Please request a new one.');
              showSnackbar('OTP has expired. Please request a new one.', 'warning');
              break;
            case 500:
              setErrorMessage('Internal server error. Please try again later.');
              showSnackbar('Internal server error. Please try again later.', 'warning');
              break;
            default:
              setErrorMessage('An unexpected error occurred.');
              showSnackbar('An unexpected error occurred.', 'error');
          }
        } else {
          // Handle network or other unexpected errors
          setErrorMessage('An error occurred. Please try again later.');
          showSnackbar('An error occurred. Please try again later.', 'error');
        }

        setTimer(0);
      }
    }
  };
  

  return (
    <div>
      <CssBaseline enableColorScheme />
      <Banner/>
      <SignInContainer direction="column" justifyContent="space-between">           
        <Card variant="outlined">
          <Typography component="h1" variant="h6">
            Promoter Details
          </Typography>
          <TextField id="outlined-basic" label="Name" variant="outlined" value={user.name} disabled={true}/>
          <TextField id="outlined-basic" label="Merchant ID" variant="outlined" value={user.id} disabled={true}/>
          <TextAreaWithButton
            errorMessage={errorMessage}
            label="Phone Number"
            inputValue={user.phone}
            onChange={setMobileNumber}
            onClick={onSend}
            buttonText={(!otpSent && !isLoading)? 'Send OTP' : (isLoading ? 'Loading...' : (timer ? `Resend in ${timer} sec` : 'Resend'))}
            ariaLabel="phone"
            disabled={isLoading || (timer > 0) || phoneVerified}
            prefilled={true}
            verified = {phoneVerified}
          />
          {otpSent && (!phoneVerified) && (
            <TextAreaWithButton
              errorMessage={errorMessage}
              label="Enter OTP"
              inputValue={otp}
              onChange={setOtp}
              onClick={onVerify}
              buttonText="Verify OTP"
              ariaLabel="otp"
              disabled={isLoading}
            />
          )}
          {errorMessage && <div style={{ color: 'red' }}>{errorMessage}</div>}
          <Divider variant="middle" sx={{color:'red'}}/>
          <ContactUs/>
        </Card>
      </SignInContainer>
    </div>
  );
};

export default Demo;
